import React from "react";
import {
    Card, Form, Checkbox, Divider, Button, InputNumber, Col,
    Row, Modal, Input, message, Radio, Upload, Spin, Icon, DatePicker,

} from 'antd';
import View from './view';
import NHFetch from "../../../utils/NHFetch";
import NHSelect from "../../common/NHSelect";
import NHFormItem from '../../common/NHFormItem';
import { getLoginUser, createUuid } from "../../../utils/NHCore";
import PropTypes from 'prop-types';
import { NHModal, NHConfirm } from '../../common/NHModal';
import { get, post } from "../../../utils/request";
const Dragger = Upload.Dragger;
const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const basicUrl = "/yxxc/";
const hjdm = "GD001_5";   //环节代码
const jfxtBasicUrl = 'api/zhxg-jfxt/';
const baseUrl = '/api/zhxg-yxwz'
/**
 * 绿色通道
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-06-26
 * Version: 1.0
 * Modify log:
 */
class Lstd extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            submitFlag: true,
            show: false,
            lstdBlyy: [], //绿色通道办理原因列表
            lstdHjsqdx: [],//绿色通道缓交申请对象列表
            hjblztData: {}, //环节办理状态信息
            lstdData: {}, //学生绿色通道办理信息
            fileList: [],
            uploading: false,
            yjje: 0,
            studentData: {},
            loading: false,
            previewVisible: false,
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'],   //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'],  //可以导入的非图片格式
            dkyhmc: '',
            dkyhList: [],//贷款银行
            dkfsList: [],//贷款类型数据
            dkfsValue: "",//贷款类型值
            lstdList: [{ value: '1', label: "是" }, { value: '0', label: "否" }],//贷款类型数据
            sqValue: "",//是否申请绿色通道
            x_hjjzrq: "",
            jfhjzt: false,//缴费环节状态

            zzbdhjid:'',//自助报到绿色通道环节id
            checkGroup: [],//绿色通道办理原因
            data: {},//绿色通道申请信息
            nextUrl: '',
            search: '',
            operable: true,//是否显示环节
            nonOperationalData: {},//不可操作的数据
            fdm: 1, //默认办理方式
            blYyList: [],//总办理原因
            blYyValue: '',//选中的办理原因
        }
    }

    //渲染前获取 绿色通道办理原因
    componentDidMount() {
        this.loadZzbdLstdPkid();
        this.loadLstdBlyy('AHGS_YXXT_LSTD_BLYY');//获取办理原因
        this.loadLstdInfo();//查询申请后的信息
    }

    componentWillReceiveProps(nextProps) {
        if ('studentData' in nextProps) {
            const studentData = nextProps.studentData;
            //查询到学生信息时才显示绿色通道环节办理业务项
            if (Object.keys(studentData).length !== 0) {
                this.setState({ show: true });
            } else {
                this.setState({ show: false });
            }
        }
        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            if (hjblztData) {
                this.setState({ hjblztData: hjblztData });
            } else {
                this.setState({ hjblztData: hjblztData });
            }
        }
    }

    // 获取办理原因
    loadLstdBlyy = (dmbz) => {
        get(baseUrl + "/openapi/yxwz/getDmk", { dmbz: dmbz })
            .then(res => {
                if (!res || res.code !== 200) return message.error('系统繁忙，请联系管理员!')
                this.setState({ blYyList: res.data })
            });
    }

    // 选择办理方式
    onChange = (event) => {
        this.props.form.setFieldsValue({ blyy: null });//重置办理原因选中值
        this.setState({ fdm: event.target.value, blYyValue: '' })
    }
    // 选择办理原因
    onChange1 = (event) => {
        this.setState({ blYyValue: event.target.value })
    }
    loadZzbdLstdPkid=()=>{
        NHFetch('api/zhxg-yxwz/openapi/yxwz/getZzbdLcPkidByHjdm', "GET", {"hjdm":"GD005_8"})
            .then(res => {
                if(res){
                    this.setState({
                        zzbdhjid:res.data
                    })
                }
            });
    }
    //查询学生的绿色通道申请信息
    loadLstdInfo = () => {
        const { xsid } = this.props.studentData;
        NHFetch('/yxwz/zzbd/lstdAhgs/getLstdInfoByXsid', "GET",{'xsid':xsid}).then(res => {
            if (res && res.code === 200) {
                if (!res.data) {
                    this.setState({
                        data: {},
                        fileList: [],
                        submitFlag: false,
                        fdm: 1,
                        blYyValue: '',
                    });
                    this.props.form.resetFields();
                    return;
                }
                let fileList = [];
                res.data['fj'] && res.data['fj'].forEach(elem => {
                    //格式化对于附件取值
                    let file = {
                        uid: elem.fjid,
                        name: elem.fjmc,
                        response: {
                            data: {
                                ssbh: elem.fjid,
                                fjmc: elem.fjmc,
                            }
                        },
                        status: 'done'
                    }
                    fileList.push(file);
                })
                if (res.data.shzt != '9') this.setState({ submitFlag: true })
                this.setState({
                    data: res.data,
                    fdm: res.data.fdm,
                    fileList,
                    blYyValue: res.data.dklx,
                })
                this.props.form.setFieldsValue({ fj: { fileList } });
            } else {
                this.setState({ data: {}, fileList: [] });
                this.props.form.resetFields();
            }
        });
    }

    // 关闭图片弹窗
    closeModal = () => this.setState({ previewVisible: false });

    // 提交
    handleSubmit = e => {
        const {zzbdhjid}=this.state;
        const { pkid: lchjid } = this.props.hjblztData;
        const { xsid } = this.props.studentData;
        this.setState({ loading: true });
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                this.setState({ loading: false });
                return false;
            }
            const fj = values['fj'];
            let fjlist = [];
            if (fj) {
                let size = fj['fileList'].length;
                let file = fj['fileList'].filter((file) => {
                    if (file.status === 'error') {
                        return false;
                    }
                    return true;
                });
                if (file.length !== size) {
                    this.props.form.setFields({
                        fj: {
                            value: fj,
                            errors: [new Error('材料上传出错，请重新上传!')],
                        }
                    });
                    this.setState({ loading: false });
                    return false;
                }

                let fileList = fj['fileList'];
                fileList.forEach(element => {
                    let fjid = element.response.data.ssbh;
                    let fjmc = element.name;
                    fjlist.push({
                        fjid: fjid,
                        fjmc: fjmc
                    });
                });
            }
            if (fjlist.length === 0) fjlist = undefined;
            const { blyy, blje, sqsm, dkyh, hzjym, pkid } = values;
            console.log('values:', values);
            try {
                const params = {
                    fj: fjlist,//附件
                    dklx: blyy,//办理原因
                    blje,//贷款金额
                    sqsm,//申请理由
                    hzjym,//回执检验码
                    dkyh,//贷款银行
                    xsid,//学生id
                    lchjid,//现场环节id
                    zzbdhjid,//自助报到环节id
                    pkid,//流程id
                    sjly: 1,//数据来源：1.迎新现场办理\2.学生申请
                    shzt: 1,//审核状态
                }
                console.log('params:', params)
                const url = pkid ? '/yxwz/zzbd/lstdAhgs/update' : '/yxwz/zzbd/lstdAhgs/insert'
                NHFetch(url, 'POST', params)
                    .then(res => {
                        this.setState({ loading: false })
                        if (!res || res.code !== 200 || res.data != 1) return message.error("提交失败!")
                        message.success("绿色通道申请提交成功!");
                        this.loadLstdInfo();
                        //办理完成回调
                        const onFinish = this.props.onFinish;
                        if (onFinish) onFinish('submit');

                    }).catch((res) => {
                        this.setState({ loading: false })
                        return res;
                    });
            } catch (error) {
                console.log('测试:', error);
            }

        });

    };


    /* 附件上传与处理部分---start */
    //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常
    handleChange = ({ fileList }) => {
        let count = 0;
        fileList.map((elem) => {
            if (elem && elem['status'] && elem['status'] === 'uploading') {
                this.setState({ uploading: true });
                return;
            } else if (elem && elem['status']) {
                count++;
            }
        })
        if (count > 0) {
            this.setState({ uploading: false });
        }
    }
    // 转化base64
    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    // 点击文件链接或预览图标时的回调
    handlePreview = file => {
        const isImage = /^image\/.*$/i.test(file.type);
        if (isImage) {
            if (file) {
                this.getBase64(file, imageUrl => {
                    this.setState({
                        previewImage: imageUrl,
                        previewVisible: true
                    });
                });
            } else {
                this.setState({
                    previewImage: file.url || file.thumbUrl,
                    previewVisible: true
                });
            }
        } else if (file && file['response'] && file['response']['data']) {//其他情况
            let isImage = true;
            let fjmc = file['response']['data']['fjmc'];
            let ssbh = file['response']['data']['ssbh'];
            if (
                !this.setJudge(fjmc, this.state.judgeImgList)
            ) {
                isImage = false;
            }

            if (isImage) {
                this.showPreview(`anonymity/docrepo/download/file?attachmentId=${ssbh}`);
            } else {
                window.open(`anonymity/docrepo/download/file?attachmentId=${ssbh}`);
            }
        }
    };

    showPreview = (url) => {
        this.setState({
            previewImage: url,
            previewVisible: true
        });
    }

    setJudge = (name, map) => {
        let flag = false;
        map.map(item => {
            if (name.indexOf(item) !== -1) {
                flag = true;
            }
        })
        return flag;
    }

    beforeUpload = (file) => {
        if (
            !(this.setJudge(file.name, this.state.judgeImgList) ||
                this.setJudge(file.name, this.state.judgeFileList))
        ) {
            message.error('不能上传该格式文件');
            return false;
        } else {
            return true;
        }
    }

    remove = (ssbh) => {
        let url = `api/docrepo/attachment/sourceId/delete?souerceId=${ssbh}`;
        NHFetch(url, "POST").then(res => {
            if (res.data && res.data > 0) {
                message.success('已删除材料.');
            }
        });
    }
    /* end */

    // 取消申请
    cancel = e => {
        const  lchjid = this.props.hjblztData.pkid;
        const  XSID  = this.props.studentData.xsid;
        const PKID = this.state.data.pkid;
        e.preventDefault();
        let params = {
            XSID,
            lchjid,
            PKID,
        }
        NHFetch( '/yxwz/zzbd/lstdAhgs/deleteByPoMap', 'POST', [params])
            .then(res => {
                this.setState({ loading: false })
                if (!res || res.code !== 200 || res.data != 1) return message.error("取消失败!")
                message.success("绿色通道取消申请成功!");
                this.loadLstdInfo();
                //办理完成回调
                const onFinish = this.props.onFinish;
                if (onFinish) onFinish('submit');

            }).catch((res) => {
            this.setState({ loading: false })
            return res;
        });
    }

    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
    }

    //上一步
    handleLast = () => {
        let onLast = this.props.onLast;
        if (onLast) {
            onLast();
        }
    }

    //下一步
    handleNext = () => {
        let onNext = this.props.onNext;
        if (onNext) {
            onNext();
        }
    }

    render() {
        const { form, lchjData = {}, hasLast, hasNext } = this.props;
        const { getFieldDecorator } = form;
        const { submitFlag, lstdBlyy, show, lstdData, yjje, loading, previewVisible,
            previewImage, dkyhmc, lstdList, sqValue, dkfsValue, lstdHjsqdx, dkfsList,
            hjsqdxlx, fdm, data, blYyList, blYyValue
        } = this.state;
        // 设置展示免缴学费
        const showList = blYyList.filter(item => item.FDM == fdm)
        const { sfdybdd = '0' } = lchjData; //是否打印报到单

        const formItemLayout = { //表单项布局
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 16 },
            }
        }

        const props = {
            name: 'file',
            action: 'anonymity/docrepo/upload',
            data: { uuid: createUuid(), type: '1' },

            onRemove: file => {
                this.setState(({ fileList }) => {
                    const index = fileList.indexOf(file);
                    const newFileList = fileList.slice();
                    newFileList.splice(index, 1);
                    this.props.form.setFieldsValue({ fj: { fileList: newFileList } });
                    return {
                        fileList: newFileList
                    };
                }, () => {
                    if (file.response && file.response.data && file.response.data.ssbh) {
                        this.remove(file.response.data.ssbh);
                    }
                });
            },
            beforeUpload: file => {
                if (!this.beforeUpload(file)) {
                    return false;
                }
                this.setState(({ fileList }) => ({
                    fileList: [...fileList, file]
                }));
                return true;
            },
            onChange: file => { this.handleChange(file) },
            onPreview: this.handlePreview,
            fileList: this.state.fileList,
        };
        return (
            <div>

                <Card type="inner" title="绿色通道业务信息">
                    {
                        !submitFlag ?
                            <div>
                                {
                                    show ?
                                        <Form onSubmit={this.handleSubmit}>
                                            <div style={{ display: 'none' }}>
                                                <NHFormItem id={'pkid'} initialValue={data['pkid']} form={form}>
                                                    <Input />
                                                </NHFormItem>
                                            </div>
                                            <NHFormItem id={'blfs'} required={true} initialValue={Number(fdm)} form={form}
                                                formItemLayout={{ labelCol: { span: 4 }, wrapperCol: { span: 16 } }} label="办理方式">
                                                <Radio.Group name="radiogroup" onChange={this.onChange}>
                                                    <Radio value={1}>免缴学费</Radio>
                                                    <Radio value={2}>缓缴学费</Radio>
                                                </Radio.Group>
                                            </NHFormItem>
                                            <NHFormItem id={'blyy'} required={true} initialValue={data['dklx'] ? data['dklx'] : null} form={form}
                                                formItemLayout={{ labelCol: { span: 4 }, wrapperCol: { span: 16 } }} label="办理原因">
                                                <Radio.Group name="radiogroup" onChange={this.onChange1}>
                                                    {
                                                        showList.map(item => {
                                                            return <Radio value={item.DM} key={item.PXH}>{item.MC}</Radio>
                                                        })
                                                    }
                                                </Radio.Group>
                                            </NHFormItem>
                                            {fdm == 2 &&
                                                <NHFormItem id={'sqsm'} required={true} initialValue={data['sqsm']} form={form}
                                                    formItemLayout={formItemLayout} label="申请理由">
                                                    <TextArea maxLength={50} placeholder="请填写申请理由" />
                                                </NHFormItem>}
                                            {(blYyValue && blYyValue === 'syddk') && <div>
                                                <NHFormItem id={'blje'} initialValue={data['blje']} form={form} formItemLayout={formItemLayout} label="贷款金额">
                                                    <InputNumber style={{ width: '100%' }} min={0} max={9999999} precision={0} placeholder="请填写贷款金额（元）" />
                                                </NHFormItem>
                                                <NHFormItem id={'dkyh'} initialValue={data['dkyh']} form={form} formItemLayout={formItemLayout} label="贷款银行">
                                                    <NHSelect sign={"dmk_yxwz_dkyh"} onChange={(v) => { }} />
                                                </NHFormItem>
                                                <NHFormItem id={'hzjym'} initialValue={data['hzjym']} form={form} formItemLayout={formItemLayout} label="回执校验码">
                                                    <Input placeholder="请输入回执校验码" />
                                                </NHFormItem>
                                            </div>}

                                            <div className="p-sw">
                                                <div className="form_item" style={{ marginLeft: '7%' }}>
                                                    <FormItem
                                                        labelCol={{ span: 3 }}
                                                        wrapperCol={{ span: 16 }}
                                                        label={'上传受理证明'}
                                                    >
                                                        {getFieldDecorator('fj')(
                                                            <Dragger {...props}>
                                                                <p className="ant-upload-drag-icon">
                                                                    <Icon type="inbox" />
                                                                </p>
                                                                <Spin spinning={this.state.uploading} />
                                                                <p className="ant-upload-text font-14">
                                                                    点击此处或拖拽文件到此
                                                                </p>
                                                            </Dragger>
                                                        )}
                                                    </FormItem>
                                                </div>
                                            </div>
                                            {data['shzt'] === '9' ?
                                                <div>
                                                    <div className="p-sw">
                                                        <div className="form_item" style={{ width: '100%', marginBottom: '24px' }}>
                                                            <Row gutter={24}>
                                                                <Col span={4} style={{ textAlign: 'right', paddingRight: 0 }}><span
                                                                    style={{ color: 'rgba(0, 0, 0, 0.85)' }}>审核意见&nbsp;: </span></Col>
                                                                <Col span={20}><span>{data['shyj']}</span></Col>
                                                            </Row>
                                                        </div>
                                                        <br />
                                                        <div className="form_item" style={{ width: '100%', marginBottom: '24px' }}>
                                                            <Row gutter={24}>
                                                                <Col span={4} style={{ textAlign: 'right', paddingRight: 0 }}><span
                                                                    style={{ color: 'rgba(0, 0, 0, 0.85)' }}>审核状态&nbsp;: </span></Col>
                                                                <Col span={20}><span style={{ color: '#0066FF' }}>驳回</span></Col>
                                                            </Row>
                                                        </div>
                                                    </div>
                                                </div> : ""}
                                        </Form>
                                        : null
                                }
                            </div>
                            :
                            <View data={data} showPreview={this.showPreview} judgeImgList={this.state.judgeImgList} setJudge={this.setJudge} />
                    }
                    <Modal
                        visible={previewVisible}
                        footer={null}
                        onCancel={this.closeModal}
                    >
                        <img
                            alt="example"
                            style={{ width: '100%' }}
                            src={previewImage}
                        />
                    </Modal>
                    <Spin style={{ position: 'absolute', top: '300px', left: '60%' }} spinning={loading} />
                </Card>
                <Divider style={{ margin: '40px 0 24px' }} />
                {
                    !submitFlag ?
                        <Button type="primary" onClick={this.handleSubmit} loading={loading}>确认办理</Button>
                        : <Button type="primary" onClick={this.cancel} loading={loading}>取消办理</Button>
                }
                {
                    sfdybdd == '1' ? <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button> : null
                }
                {
                    hasLast ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button> : null
                }
                {
                    hasNext ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button> : null
                }
            </div>
        )
    }
}

Lstd.propTypes = {
    studentData: PropTypes.object, //学生信息
    hjblztData: PropTypes.object, //环节办理状态信息
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool, //是否有上一步
    hasNext: PropTypes.bool, //是否有下一步
    onLast: PropTypes.func, //上一步事件回调
    onNext: PropTypes.func, //下一步事件回调
    onFinish: PropTypes.func, //确认办理、取消办理完成回调
    onPrint: PropTypes.func, //打印报到单
}

const lstd = Form.create()(Lstd);
export default lstd;


// WEBPACK FOOTER //
// ./components/yxxc/steps/ahgsLstd.js